import { Typography } from "@mui/material";
import { UrlConfig } from "src/shared/Utils/paths";

export const listUpdates = [
  {
    title: "Relatório de Produção por Gerente",
    description: (
      <Typography sx={{ fontSize: "14px", mb: "5px" }} color="text.secondary">
        <strong>Visualize a produção consolidada por gerente</strong>.
        Acompanhe total de contratos, vidas e mensalidades com filtros por
        período, opção de gerente específico e exportação em PDF.
      </Typography>
    ),
    url: UrlConfig.relatoriosProducao.producaoGerente.url,
    createdAt: "Lançado em 16/03/2026",
    limitNovidade: "2026/03/31",
  },
  {
    title: "Relatório de Contrato com Parcelas",
    description: (
      <Typography sx={{ fontSize: "14px", mb: "5px" }} color="text.secondary">
        <strong>Visualize contratos com suas parcelas em um único relatório</strong>.
        Consulte datas, valores, vidas, status de recebimento e exporte em PDF com
        filtros de cliente e código da proposta.
      </Typography>
    ),
    url: UrlConfig.relatoriosProducao.contractsToInstallments.url,
    createdAt: "Lançado em 10/03/2026",
    limitNovidade: "2026/03/30",
  },
  {
    title: "Relatório de Pagamentos",
    description: (
      <Typography sx={{ fontSize: "14px", mb: "5px" }} color="text.secondary">
        <strong>Consulte pagamentos por corretor, supervisor e gerente</strong>.
        Visualize os valores pagos com agrupamento por função e exporte em PDF.
      </Typography>
    ),
    url: UrlConfig.relatoriosProducao.confirmationPayment.url,
    createdAt: "Lançado em 02/03/2026",
    limitNovidade: "2026/03/30",
  },
  {
    title: "Relatório de Aniversariantes de Produtores",
    description: (
      <Typography sx={{ fontSize: "14px", mb: "5px" }} color="text.secondary">
        <strong>Consulte aniversariantes de produtores por período</strong>.
        Filtre por dia e mês, visualize quem faz aniversário hoje ou no período e
        exporte o relatório em PDF.
      </Typography>
    ),
    url: UrlConfig.relatoriosAniversariantes.produtores.url,
    createdAt: "Lançado em 17/02/2026",
    limitNovidade: "2026/03/31",
  },
  {
    title: "Recibo de Comprovante de Pagamento",
    description: (
      <Typography sx={{ fontSize: "14px", mb: "5px" }} color="text.secondary">
        <strong>Gere recibo de comprovante de pagamento em parcelas</strong> para
        oferecer ao cliente. Crie comprovantes profissionais em PDF com todos os
        dados da parcela e do pagamento.
      </Typography>
    ),
    url: UrlConfig.lancamentos.parcelas.url,
    createdAt: "Lançado em 26/01/2026",
    limitNovidade: "2026/02/28",
  },
  {
    title: "Relatório de Produção por Supervisor",
    description: (
      <Typography sx={{ fontSize: "14px", mb: "5px" }} color="text.secondary">
        <strong>Visualize relatórios detalhados de produção por supervisor</strong>.
        Analise métricas, contratos e performance de cada supervisor de forma
        completa e organizada.
      </Typography>
    ),
    url: UrlConfig.relatoriosProducao.producaoSupervisor.url,
    createdAt: "Lançado em 26/01/2026",
    limitNovidade: "2026/02/28",
  },
  {
    title: "Relatório de Parcelas Abertas",
    description: (
      <Typography sx={{ fontSize: "14px", mb: "5px" }} color="text.secondary">
        <strong>Gere relatórios completos de parcelas abertas</strong>. Visualize
        e analise todas as parcelas em aberto com filtros avançados e exportação
        para PDF.
      </Typography>
    ),
    url: UrlConfig.relatoriosProducao.confirmationParcelasAbertas.url,
    createdAt: "Lançado em 26/01/2026",
    limitNovidade: "2026/02/28",
  },
  {
    title: "Exportar Parcelas para Excel",
    description: (
      <Typography sx={{ fontSize: "14px", mb: "5px" }} color="text.secondary">
        <strong>Exporte todas as parcelas para Excel</strong> conforme os
        filtros aplicados. Baixe os dados completos de forma rápida e fácil para
        análises externas.
      </Typography>
    ),
    url: UrlConfig.lancamentos.parcelas.url,
    createdAt: "Lançado em 20/01/2026",
    limitNovidade: "2026/02/28",
  },
  {
    title: "PDF de Comissão do Produtor",
    description: (
      <Typography sx={{ fontSize: "14px", mb: "5px" }} color="text.secondary">
        <strong>Gere PDF das comissões do produtor</strong> para impressão e
        compartilhamento. Visualize e imprima os detalhes das comissões de forma
        profissional.
      </Typography>
    ),
    url: UrlConfig.comissao.produtor.url,
    createdAt: "Lançado em 20/01/2026",
    limitNovidade: "2026/02/10",
  },
  {
    title: "Métricas nos Cards de Parcelas",
    description: (
      <Typography sx={{ fontSize: "14px", mb: "5px" }} color="text.secondary">
        <strong>Analise valores e números diretamente nos cards</strong> de
        parcelas. Visualize métricas importantes como totais e valores de entradas de forma rápida.
      </Typography>
    ),
    url: UrlConfig.lancamentos.parcelas.url,
    createdAt: "Lançado em 20/01/2026",
    limitNovidade: "2026/02/10",
  },
  {
    title: "Nova Tela de dashboard de métricas",
    description: (
      <Typography sx={{ fontSize: "14px", mb: "5px" }} color="text.secondary">
        <strong>
          Na tela inicial você pode visualizar as métricas de produção de contratos, parcelas (vencidas / pendentes), produção por operadora, ranking de corretores e muito mais.
        </strong>
      </Typography>
    ),
    url: UrlConfig.home,
    createdAt: "Lançado em 23/10/2025",
    limitNovidade: "2025/11/15",
  },
  {
    title: "Nova funcionalidade",
    description: (
      <Typography sx={{ fontSize: "14px", mb: "5px" }} color="text.secondary">
        <strong>
          Agora você pode anexar comprovantes de pagamento e notas fiscais na
          conta corrente
        </strong>
        , os vendedores podem visualizar e anexar documentos diretamente pelo
        acesso deles.
      </Typography>
    ),
    url: UrlConfig.produtores.contaCorrente.url,
    createdAt: "Lançado em 20/08/2025",
    limitNovidade: "2025/09/30",
  },
  {
    title: "Gerar pagamento (Resumo de pagamento)",
    description: (
      <Typography sx={{ fontSize: "14px", mb: "5px" }} color="text.secondary">
        <strong>Novo resumo de pagamento em &apos;Gerar pagamento&apos;</strong>
        , apenas dados importantes para realizar o pagamento. Simplifique a sua
        vida.
      </Typography>
    ),
    url: UrlConfig.pagamentos.recibos.url,
    createdAt: "Lançado em 18/08/2025",
    limitNovidade: "2025/08/31",
  },
  {
    title: "Nova funcionalidade",
    description: (
      <Typography sx={{ fontSize: "14px", mb: "5px" }} color="text.secondary">
        <strong>Agora você pode salvar arquivos dentro das propostas</strong>,
        salve Documentos e a Proposta do seu cliente.
      </Typography>
    ),
    url: UrlConfig.lancamentos.contratos.url,
    createdAt: "Lançado em 13/08/2025",
    limitNovidade: "2025/09/30",
  },

  {
    title: "Nova funcionalidade - IA 🤖",
    description: (
      <Typography sx={{ fontSize: "14px", mb: "5px" }} color="text.secondary">
        <strong>Importação com Inteligência Artificial</strong>: Quando for
        criar um contrato, você pode clicar em &rsquo;Importar dados com
        IA&rsquo; 🤖e deixa ela preencher tudo.
      </Typography>
    ),
    url: UrlConfig.lancamentos.contratos.url,
    createdAt: "Lançado em 14/07/2025",
    limitNovidade: "2025/08/31",
  },
];
